import React from 'react';
import { useTranslation } from 'react-i18next';
import { emoText } from '../../shell/EmojiIcons';
import EnumSelect from '../EnumSelect';
import { TextInput } from '../inputs/Input';

// Reason dropdown + optional note for the sell-side return form (rendered inside its field grid).
export default function ReturnReasonFields({ reasons, code, note, onCode, onNote, labelStyle, inputStyle }) {
  const { t } = useTranslation('returnReasons');
  return (
    <>
      <label style={labelStyle}>{t('form.reason')} *
        <EnumSelect bare testid="money-event-reason" value={code} onChange={v => onCode(v)}>
          <option value="">{t('form.select')}</option>
          {reasons.map(r => <option key={r.code} value={r.code}>{emoText(r.label)}</option>)}
        </EnumSelect>
      </label>
      <label style={labelStyle}>{t('form.note')}
        <TextInput data-testid="money-event-reason-note" type="text" value={note} onChange={e => onNote(e.target.value)} style={inputStyle} />
      </label>
    </>
  );
}
